module.exports = __webpack_public_path__ + "media/content-creator/fmcg-2-a58168b5.png";